import React from "react";
import { FormattedMessage } from "react-intl";

export const playerPremiumData: React.ReactNode[] = [
  <FormattedMessage
    defaultMessage="Release yourself from any contract"
    id="O3OvGa"
  />,
  <FormattedMessage defaultMessage="Change VPG Username." id="XPCx0d" />,
  <FormattedMessage
    defaultMessage="Entry into Premium Tournaments"
    id="iEAL4l"
  />,
  <FormattedMessage defaultMessage="Premium Verification Badge" id="J2umwa" />,
  <FormattedMessage
    defaultMessage="Dedicated support from deputy admins"
    id="ZZjVJb"
  />,
  <FormattedMessage
    defaultMessage="Medals missing (contact admins for them to be added)"
    id="fRD6Cu"
  />,
  <FormattedMessage defaultMessage="No advertisements on the apps" id="94o3PT" />,
  <FormattedMessage
    defaultMessage="No limits on the amount of social posts"
    id="g9yu2b"
  />,
  <FormattedMessage
    defaultMessage="No limits on the amount of free agent posts"
    id="7rGhN+"
  />,
  <FormattedMessage
    defaultMessage="No limits on the amount of chats"
    id="F7nX8u"
  />,
  <FormattedMessage defaultMessage="5 Free Agent posts per day" id="3OuGin" />,
  <FormattedMessage
    defaultMessage="Ability to create group chats"
    id="ouulql"
  />,
  <FormattedMessage
    defaultMessage="Ability to add images to social posts"
    id="Sat+TB"
  />,
];

export const teamPremiumData: React.ReactNode[] = [
  <FormattedMessage defaultMessage="Dedicated Support Team." id="fjKTvp" />,
  <FormattedMessage
    defaultMessage="Get added into leagues faster."
    id="KsGbJl"
  />,
  <FormattedMessage
    defaultMessage="Trophies missing (contact admins for them to be added)."
    id="Bj64zG"
  />,
  <FormattedMessage
    defaultMessage="Premium teams don't need a GK in the lower leagues (5x per season)."
    id="qqXtvu"
  />,
  <FormattedMessage
    defaultMessage="Match Kick Off Delay 15 minutes."
    id="OHKGjK"
  />,
  <FormattedMessage
    defaultMessage="Reschedule matches 5 times per season."
    id="X5fYy7"
  />,
  <FormattedMessage
    defaultMessage="Free Entry into Premium Tournaments."
    id="gGUY5t"
  />,
  <FormattedMessage
    defaultMessage="No limits on the amount of social posts"
    id="g9yu2b"
  />,
  <FormattedMessage
    defaultMessage="No limits on the amount of recruitment posts"
    id="vZg6vY"
  />,
  <FormattedMessage
    defaultMessage="Ability to add images to social posts"
    id="Sat+TB"
  />,
  <FormattedMessage
    defaultMessage="Ability to create group chats"
    id="ouulql"
  />,
];
